import React, {useEffect, useState} from 'react';
import {resultDashboard, LastDisk} from "../core/model";
import {KTSVG} from "../../../../_metronic/helpers";
import {Dropdown1} from "../../../../_metronic/partials";
import {wordsToNumber} from "@persian-tools/persian-tools";
import {SwalClose, SwalError, SwalLoading} from "../../../../_metronic/helpers/components/Swal";
import {LastDisks} from "../core/Request";
import {useThemeMode} from "../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import clsx from "clsx";
import DatePicker, { DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

type Props = {
    className: string
}
const LastDiskComponent : React.FC<Props> = ({className}) => {
    const {mode} = useThemeMode()
    const [data,setData] = useState<resultDashboard<LastDisk[]>>()
    const [selectedDate, setSelectedDate] = useState('');
    const [loading,setLoading] = useState<boolean>(false)
    useEffect(()=>{
        bindData()
    },[])
    const clear =()=>{
        setSelectedDate('')
        bindData()
    }
    const bindData = async ()=>{
        try {
            setLoading(true)
            const {data:response} =await LastDisks(selectedDate)
            setData(response)
            setLoading(false)
        }catch (err:any){
            setLoading(false)
            SwalError(err.response.data.message)
        }
    }
    const getColorBg = (num:number):string=>{
        const index = wordsToNumber(String(num).slice(-1))
        switch (index) {
            case 0 :{
                return 'primary'
            }
            case 1 :{
                return 'secondary'
            }
            case 2 :{
                return 'success'
            }
            case 3 :{
                return 'danger'
            }
            case 4 :{
                return 'warning'
            }
            case 5 :{
                return 'info'
            }
            case 6 :{
                return 'light '
            }
            case 7 :{
                return 'dark'
            }
            case 8 :{
                return 'body'
            }
            case 9 :{
                return 'muted'
            }
            default : return ''

        }
    }
    useEffect(()=>{
        bindData()
    },[selectedDate])
    return (
        <div className={`card ${className}`}>
            {/* begin::Header */}
            <div className='card-header align-items-center border-0 mt-4'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='fw-bold mb-2 text-dark'> لیست ها</span>
                    <span className='text-muted fw-semibold fs-7'>{data?.date}</span>
                </h3>
                <div className='card-toolbar'>
                    {/* begin::Menu */}
                    <button
                        disabled={loading}
                        type='button'
                        className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                    >
                        <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
                    </button>
                    <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                        <div className='px-7 py-5'>
                            <div className='fs-5 text-dark fw-bold'>انتخاب بازه زمانی</div>
                        </div>

                        <div className='separator border-gray-200'></div>

                        <div className='px-7 py-5'>
                            <div className='mb-10'>
                                <label className='form-label fw-semibold'>تاریخ : </label>

                                <div>
                                    <DatePicker
                                        disabled={loading}
                                        calendar={persian}
                                        style={{
                                            height: "38px",
                                            fontSize: '14px',
                                            width: '100%',
                                            backgroundColor: 'var(--kt-input-solid-bg)',
                                            borderColor: 'var(--kt-input-solid-bg)',

                                        }}
                                        placeholder='__/__/____'
                                        containerStyle={{
                                            width: "100%"
                                        }}
                                        onChange={(e: DateObject) => {
                                            if (e) {
                                                setSelectedDate(`${e.year}/${e.month.number}/${e.day}`)
                                            }


                                        }}
                                        value={selectedDate}
                                        calendarPosition={`left-start`}
                                        fixMainPosition={true}
                                        fixRelativePosition={true}
                                        locale={persian_fa}
                                        // disabled={formik.isSubmitting || isUserLoading}

                                    />
                                </div>
                            </div>



                            <div className='d-flex justify-content-end'>
                                <button
                                    onClick={clear}
                                    type='reset'
                                    className={clsx('btn btn-sm btn-active-light-primary me-2', {
                                        'btn-light ': mode === 'light',
                                    })}
                                    data-kt-menu-dismiss='true'
                                    disabled={loading}
                                >
                                    Reset
                                </button>


                            </div>
                        </div>
                    </div>
                    {/* end::Menu */}
                </div>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body pt-5'>
                <div

                    className="scroll-y me-n5 pe-5"
                    data-kt-scroll='true'
                    data-kt-scroll-activate='{default: true, lg: true}'
                    data-kt-scroll-max-height='280px'
                    data-kt-scroll-offset={'5px'}
                >
                    <div className={`${loading && 'overlay overlay-block '} rounded`}>
                        <div className="overlay-wrapper p-5">
                            {/* begin::Timeline */}
                            <div className='timeline-label'>
                                {
                                    data?.data.map((item,index)=>(
                                        <div key={`DiskId-${index}`} className='timeline-item'>
                                            {/* begin::Label */}
                                            <div className='timeline-label fw-bold text-gray-800 fs-6' >{item.dateTime}</div>
                                            {/* end::Label */}
                                            {/* begin::Badge */}
                                            <div className='timeline-badge'>
                                                <i className={`fa fa-genderless text-${getColorBg(index)} fs-1`}></i>
                                            </div>
                                            {/* end::Badge */}
                                            {/* begin::Text */}
                                            <div className='fw-bold text-gray-800 ps-3'>
                                                {`${item.userName} , ${item.kargah},`}
                                                <span> {item.yy} - {item.mm}</span>
                                            </div>
                                            {/* end::Text */}
                                        </div>
                                    ))
                                }

                            </div>
                            {/* end::Timeline */}
                            {loading && (
                                <div className="overlay-layer rounded bg-dark bg-opacity-5">
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* end: Card Body */}
        </div>
    );
};

export default LastDiskComponent;
